import { useRef, useEffect } from 'react';

export const useDropdownHandlers = (
  isMobile,
  isDropdownOpen,
  isServicesOpen,
  isVendorsOpen,
  toggleDropdown,
  closeDropdown,
  setIsServicesOpen,
  setIsVendorsOpen,
  cancelCloseTimer,
  startCloseTimer
) => {
  const servicesCloseTimeoutRef = useRef(null);
  const vendorsCloseTimeoutRef = useRef(null);

  const handleSolutionClick = (e) => {
    e.preventDefault();
    toggleDropdown();
  };

  const handleSolutionMouseEnter = () => {
    if (!isMobile && !isDropdownOpen) {
      toggleDropdown();
    }
    if (isServicesOpen || isVendorsOpen) {
      setIsServicesOpen(false);
      setIsVendorsOpen(false);
    }
    cancelCloseTimer();
  };

  const handleMenuMouseLeave = () => {
    startCloseTimer();
  };

  const handleMenuMouseEnter = () => {
    cancelCloseTimer();
  };

  const handleServicesClick = (e) => {
    e.preventDefault();
    setIsServicesOpen(!isServicesOpen);
    if (isDropdownOpen) {
      closeDropdown();
    }
  };

  const handleServicesMouseEnter = () => {
    if (!isMobile && !isServicesOpen) {
      setIsServicesOpen(true);
    }
    if (isDropdownOpen) {
      closeDropdown();
    }
    if (isVendorsOpen) {
      setIsVendorsOpen(false);
    }
    if (servicesCloseTimeoutRef.current) {
      clearTimeout(servicesCloseTimeoutRef.current);
    }
  };

  const handleServicesMouseLeave = () => {
    if (servicesCloseTimeoutRef.current) {
      clearTimeout(servicesCloseTimeoutRef.current);
    }
    servicesCloseTimeoutRef.current = setTimeout(() => {
      setIsServicesOpen(false);
    }, 1000);
  };

  const handleServicesClose = () => {
    setIsServicesOpen(false);
  };

  const handleVendorsClick = (e) => {
    setIsVendorsOpen(!isVendorsOpen);
    if (isDropdownOpen) {
      closeDropdown();
    }
  };

  const handleVendorsMouseEnter = () => {
    if (!isMobile && !isVendorsOpen) {
      setIsVendorsOpen(true);
    }
    if (isServicesOpen) {
      setIsServicesOpen(false);
    }
    if (isDropdownOpen) {
      closeDropdown();
    }
    if (vendorsCloseTimeoutRef.current) {
      clearTimeout(vendorsCloseTimeoutRef.current);
    }
  };

  const handleVendorsMouseLeave = () => {
    if (vendorsCloseTimeoutRef.current) {
      clearTimeout(vendorsCloseTimeoutRef.current);
    }
    vendorsCloseTimeoutRef.current = setTimeout(() => {
      setIsVendorsOpen(false);
    }, 1000);
  };

  const handleVendorsClose = () => {
    setIsVendorsOpen(false);
  };

  useEffect(() => {
    return () => {
      if (servicesCloseTimeoutRef.current) {
        clearTimeout(servicesCloseTimeoutRef.current);
      }
    };
  }, []);

  return {
    handleSolutionClick,
    handleSolutionMouseEnter,
    handleMenuMouseLeave,
    handleMenuMouseEnter,
    handleServicesClick,
    handleServicesMouseEnter,
    handleServicesMouseLeave,
    handleServicesClose,
    handleVendorsClick,
    handleVendorsMouseEnter,
    handleVendorsMouseLeave,
    handleVendorsClose,
    servicesCloseTimeoutRef
  };
}; 